module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._g(_vm._b({
    staticClass: "ui_icon",
    class: _vm.getCssClass,
    style: (_vm.getStyle)
  }, 'div', _vm.$attrs, false), _vm.$listeners), [_c(_vm.iconName, {
    tag: "component"
  }), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a1428aa","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/AppSvgIcon.vue
// module id = 7348fae70a7968962857
// module chunks = 89